/**
 * Client-side lithology helper. Mirrors `commodities.js` — fetches once and
 * caches in module scope + localStorage so components can call
 * getLithologyCategories() synchronously after boot.
 */
import api from "@/lib/api";

const CACHE_KEY = "smin_lithologies_v1";
let CACHE = null;

const FALLBACK = [{
  category: "Common",
  items: ["Overburden", "Oxide Ore", "Sulphide Ore", "Waste"],
}];

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch { return null; }
}

export async function preloadLithologies() {
  if (CACHE) return CACHE;
  const cached = loadFromStorage();
  if (cached) { CACHE = cached; }
  try {
    const { data } = await api.get("/lithologies");
    if (Array.isArray(data.categories) && data.categories.length) {
      CACHE = data.categories;
      localStorage.setItem(CACHE_KEY, JSON.stringify(CACHE));
    }
  } catch {
    if (!CACHE) CACHE = FALLBACK;
  }
  return CACHE;
}

export function getLithologyCategories() {
  return CACHE || loadFromStorage() || FALLBACK;
}
